import styled from "styled-components";
import theme from "common/theme";
export const GeneratorDataPointsAreaContainer = styled.div`

    .custom-line {
      position: absolute;
    }

    .data-point {
      transform: translate(-50%, -50%);
      position: absolute;
      justify-content: center;
      display: flex;
      min-width: 1px;
      min-height: 1px;
    }

    .average-line {
      border-top: dashed 1px ${theme.colors.gray800};
      transform: translateY(-1px);
    }
`

